import MenuButton from "elements/MenuButton";

export default function MenuTaxes() {

    return (
        <div className='menu_button_container'>
            <MenuButton 
                label={"Taxes"}
                to={"/taxes"}
            />
            <MenuButton 
                label={"Types"}
                to={"/taxes/tax-types"}
            />
            <MenuButton 
                label={"Categories"}
                to={"/taxes/tax-categories"}
            />
        </div>
    )
}